import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { PieCoopen } from '@/components/MarcaBet';
import { Mudanza, debeMudarse } from '@/components/Mudanza';
import { useAuth } from '@/context/AuthContext';
import LoginPage from '@/pages/LoginPage';
import Dashboard from '@/pages/Dashboard';
import FacturaDetail from '@/pages/FacturaDetail';
import AdminUsuarios from '@/pages/AdminUsuarios';
import AdminConfiguracion from '@/pages/AdminConfiguracion';
import AdminSuppliers from '@/pages/AdminSuppliers';
import AdminEquivalencias from '@/pages/AdminEquivalencias';
import AdminServicios from '@/pages/AdminServicios';
import AdminCodigosContables from '@/pages/AdminCodigosContables';
import Analitica from '@/pages/Analitica';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

function App() {
  // La instancia vieja no muestra la app: avisa y manda al sitio nuevo.
  return debeMudarse() ? <Mudanza /> : <Rutas />;
}

function Rutas() {
  // El login trae su propio pie (lo necesita adentro del layout centrado); el
  // resto de las pantallas lo reciben acá, así no hay que acordarse en cada una.
  const enLogin = useLocation().pathname === '/login';
  return (
    <>
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/factura/:id"
        element={
          <ProtectedRoute>
            <FacturaDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/usuarios"
        element={
          <ProtectedRoute>
            <AdminUsuarios />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/configuracion"
        element={
          <ProtectedRoute>
            <AdminConfiguracion />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/suppliers"
        element={
          <ProtectedRoute>
            <AdminSuppliers />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/suppliers/:supplierId/equivalencias"
        element={
          <ProtectedRoute>
            <AdminEquivalencias />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/servicios"
        element={
          <ProtectedRoute>
            <AdminServicios />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/codigos-contables"
        element={
          <ProtectedRoute>
            <AdminCodigosContables />
          </ProtectedRoute>
        }
      />
      <Route
        path="/analitica"
        element={
          <ProtectedRoute>
            <Analitica />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    {!enLogin && <PieCoopen />}
    </>
  );
}

export default App;
